import { GroupMemberDto } from './groupMemberDto';
import { GroupDetailsDto } from './groupDetailsDto';

export class GroupUpdateDto {
  constructor(
    public readonly groupId: string,
    public readonly businessId: string,
    public readonly groupDetails: GroupDetailsDto,
    public readonly assignedGroupMembers: GroupMemberDto[]) { }
}